import { render } from "./ProfilCard.vue?vue&type=template&id=6a88b65c&scoped=true"
import script from "./ProfilCard.vue?vue&type=script&lang=js"
export * from "./ProfilCard.vue?vue&type=script&lang=js"

import "./ProfilCard.vue?vue&type=style&index=0&id=6a88b65c&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a88b65c"]])

export default __exports__